import React, { useEffect, useRef } from 'react';
import { LocalAudioTrack, RemoteAudioTrack } from 'twilio-video';

interface Props {
  track: LocalAudioTrack | RemoteAudioTrack;
}

const AudioTrack: React.FC<Props> = ({ track }: Props) => {
  const ref = useRef<HTMLAudioElement>(null!);

  useEffect(() => {
    const element = ref.current;
    track.attach(element);

    return () => {
      track.detach(element);
    };
  }, [track]);

  return <audio ref={ref} />;
};

export default AudioTrack;
